import React from "react";
import { system } from "styled-system";
import { styled, EmotionComponent } from "../../styled";
import { Box, BoxProps } from "../..";

const bottomBgColorProps = system({
  bottomBgColor: {
    property: "backgroundColor",
    scale: "colors",
  },
});

type BgImgBoxProps = BoxProps & {
  /** Start pencentage for bottom content part */
  bottomStartPercentage?: number;
  /** Skew degree for bottom content part background*/
  bottomSkewDegree?: number;
  /** Background color for bottom content part */
  bottomBgColor?: string;
};

const BgImgBox: EmotionComponent<BgImgBoxProps> = styled(Box)<BgImgBoxProps>`
  background-size: 100% auto;
  background-repeat: no-repeat;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 0;
    ${(props) =>
      props.bottomStartPercentage &&
      `bottom: -${props.bottomStartPercentage}%;`}
    ${(props) =>
      props.bottomSkewDegree &&
      `transform: skewY(${props.bottomSkewDegree}deg);`}
    ${bottomBgColorProps}
  }
`;

export type FeatureTileProps = BgImgBoxProps & {
  /** Height/width ratio */
  widthHeightRatio?: number;
  /** Container props */
  containerProps?: BoxProps;
  /** ImgBox props */
  imgBoxProps?: BoxProps;
  /** ContentBox props */
  contentBoxProps?: BoxProps;
  children: React.ReactNode;
};

export const FeatureTile: React.FC<FeatureTileProps> = ({
  backgroundImage,
  widthHeightRatio,
  bottomStartPercentage,
  bottomSkewDegree,
  bottomBgColor,
  containerProps,
  imgBoxProps,
  contentBoxProps,
  children,
}) => {
  return (
    <Box flex="1 1 auto" width="50%" p="5px" {...containerProps}>
      <BgImgBox
        position="relative"
        width="100%"
        height="0"
        pb={widthHeightRatio ? `${widthHeightRatio * 100}%` : undefined}
        border="1px solid #ddd"
        overflow="hidden"
        backgroundImage={`url(${backgroundImage})`}
        bottomStartPercentage={bottomStartPercentage}
        bottomSkewDegree={bottomSkewDegree}
        bottomBgColor={bottomBgColor}
        {...imgBoxProps}
      >
        <Box
          position="absolute"
          left="0"
          right="0"
          bottom="0"
          color="white"
          textAlign="center"
          p="5px 10px 7px"
          zIndex={1}
          {...contentBoxProps}
        >
          {children}
        </Box>
      </BgImgBox>
    </Box>
  );
};

FeatureTile.displayName = "FeatureTile";

FeatureTile.defaultProps = {
  widthHeightRatio: 0.915,
  bottomStartPercentage: 66,
  bottomSkewDegree: 5,
  bottomBgColor: "clubCatch.transpBg",
};

export default FeatureTile;
